import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_matxbn4vdk: FaireBrandEntity = {
  token: "b_matxbn4vdk",
  type: "brand",
  name: "Imported Brand Three",
  avatarUrl: "https://cdn.faire.com/fastly/example-brand-logo-3.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/example-brand-logo-3.jpeg",
  location: "United States",
  minimumOrderDollars: 50,
  rating: 4.5,
  description: "Third canonical imported brand entity.",
  meta: {
    source: "api",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
